import { Injectable } from '@angular/core';

export type JwtBasePayload = {
  exp: number;
  data: unknown;
};

export type JwtCirPayload = JwtBasePayload & {
  data: {
    customer_response_id: number;
  };
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public decodeCirJwt(jwtString: string | null): JwtCirPayload | undefined {
    if (!jwtString) {
      return undefined;
    }

    try {
      const token = jwtString.split('.')[1]; // only grab the token
      return token ? JSON.parse(window.atob(token)) : undefined;
    } catch {
      return undefined;
    }
  }

  public isCirJwtValid(jwtString: string | null): boolean {
    const jwtPayload = this.decodeCirJwt(jwtString);
    if (!jwtPayload || jwtPayload === null) return false;
    // false if token date = to or before today, true if greater than today.
    const isExpired = jwtPayload.exp <= Date.now() / 1000;
    return !isExpired;
  }

  public isCirJwtExpired(jwtPayload: JwtCirPayload): boolean {
    // false if token date = to or before today, true if greater than today.
    const isExpired = jwtPayload.exp <= Date.now() / 1000;
    return isExpired;
  }
}
